import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useMicrosites, invalidateAdminShell } from "../hooks/useAdminShell";

const EditingMicrositeContext = createContext(null);

const STORAGE_KEY = "admin_selected_microsite_id";

export function EditingMicrositeProvider({ children }) {
  // Wave 3 C5: microsites come from the cached admin-shell bundle.
  const { data: microsites = [], isLoading: loading } = useMicrosites();
  const [selectedId, setSelectedId] = useState(() => localStorage.getItem(STORAGE_KEY) || "all");
  const fetchMicrosites = useCallback(() => invalidateAdminShell(), []);

  // If previously selected id no longer exists, reset to "all"
  useEffect(() => {
    if (!loading && selectedId !== "all" && !microsites.find((m) => m.id === selectedId)) {
      setSelectedId("all");
      localStorage.removeItem(STORAGE_KEY);
    }
  }, [loading, microsites, selectedId]);

  const selectMicrosite = (id) => {
    setSelectedId(id);
    if (id === "all") {
      localStorage.removeItem(STORAGE_KEY);
    } else {
      localStorage.setItem(STORAGE_KEY, id);
    }
  };

  const selectedMicrosite = selectedId === "all" ? null : microsites.find((m) => m.id === selectedId) || null;
  const isAllSites = selectedId === "all";

  return (
    <EditingMicrositeContext.Provider value={{
      microsites,
      selectedId,
      selectedMicrosite,
      isAllSites,
      selectMicrosite,
      loading,
      refetch: fetchMicrosites,
    }}>
      {children}
    </EditingMicrositeContext.Provider>
  );
}

export function useEditingMicrosite() {
  const ctx = useContext(EditingMicrositeContext);
  if (!ctx) throw new Error("useEditingMicrosite must be inside EditingMicrositeProvider");
  return ctx;
}
